import $ from 'jquery';
import _get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import slickArrow from './slick/arrow';
import './slick-accessible';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import { get } from '../lib/props';


export const BLOCK_NAME = 'image-carousel';

/**
 *
 * AB Test 790 PDP Increased Slick Sensitivity
 */
const increasedSensitivity = get('pdp.slickSensitivity', false);


// When the slide is changing
function playPauseVideo(slick, control) {
  const currentSlide = slick.find('.slick-current');
  const slideType = currentSlide.find('.slick-slideshow__slide').data('media');
  const player = currentSlide.find('iframe').get(0) || currentSlide.find('video').get(0);

  if (slideType !== 'video' && slideType !== 'youtube') return;

  if (player !== null) {
    if (control === 'play') {
      player.play();
    } else {
      player.pause();
    }
  }
}

function renderVideoMarkup($slide, videoURL, posterURL) {
  const $anchor = $slide.find('a');
  let $video = $slide.find('video');

  if ($video.length === 0) {
    $video = $(`<video autoplay muted loop='loop' playsinline style="width: 68%;margin-left: auto;margin-right: auto;" poster='${posterURL}'>
      <source src='${videoURL}'>
    </video>
    `);

    if ($anchor.length > 0) {
      $anchor.append($video);
    } else {
      $slide.append($video);
    }
  }

  return $video;
}

function addMuteButton($slide, $video) {
  const video = $video[0];
  const muteButtonClass = 'js-video-mute-btn';
  let $muteButton = $video.find(`.${muteButtonClass}`);
  if ($muteButton.length > 0 || $slide.data('video-sound') === false) return;

  $muteButton = $(`
    <button class='${muteButtonClass} u-color--white' style='position:absolute;bottom: 10px;right: 10px;background:transparent; padding: 10px;'>
      <span class='js-mute-off icon icon--search icon--sm' style='display:none;'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.14 16'><path d='M17.13 7.69c-.03-.73-.14-1.43-.34-2.11-.17-.58-.4-1.13-.68-1.65 0-.01-.01-.02-.02-.04-.03-.06-.07-.12-.1-.18l-.18-.3c-.05-.07-.09-.14-.14-.21a8.468 8.468 0 0 0-3.9-3.12.832.832 0 0 0-.88.12c-.27.21-.4.48-.4.83 0 .17.05.33.14.48.1.14.23.25.4.31 1.27.51 2.29 1.32 3.06 2.43.28.4.51.82.68 1.26.23.58.38 1.19.44 1.83v.07c0 .05 0 .09.01.14v.92c0 .05 0 .09-.01.14v.07c-.06.64-.21 1.25-.44 1.83-.18.44-.41.86-.68 1.26-.24.35-.51.68-.81.97-.45.45-.97.82-1.54 1.13-.23.12-.47.23-.71.33-.17.06-.31.17-.4.31-.02.03-.03.06-.05.09v.02s0 .02-.01.03c-.05.1-.07.21-.07.32 0 .34.15.65.41.84.27.21.56.25.88.12.13-.05.27-.11.39-.17.34-.15.66-.32.96-.51.54-.34 1.04-.73 1.49-1.17.38-.38.73-.8 1.05-1.26.05-.07.09-.14.14-.21l.18-.3c.04-.06.07-.12.1-.18 0-.01.01-.02.02-.04.28-.52.51-1.07.68-1.65.2-.68.31-1.38.34-2.11v-.64Z' /><path d='M12.22 10.26c.17-.29.31-.58.41-.89.07-.21.13-.42.16-.63.04-.23.06-.46.06-.7v-.06c0-.24-.02-.47-.06-.7-.1-.54-.29-1.05-.57-1.52-.42-.7-1-1.22-1.75-1.57v7.65c.75-.35 1.33-.87 1.75-1.57ZM7.99 1.83c-.39-.17-.73-.1-1.04.2L4.76 4.22l-.95.95H.95c-.27 0-.5.09-.68.27S0 5.85 0 6.12v3.81c0 .27.09.5.27.68s.41.27.68.27h2.86l3.14 3.14c.3.3.65.37 1.04.2.39-.16.58-.46.58-.88V2.73c0-.43-.19-.73-.58-.89Z' /></svg></span>
      <span class='js-mute-on icon icon--search icon--sm'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.17 16'><path d='M17.16 7.7c-.03-.73-.14-1.43-.34-2.11-.17-.58-.4-1.13-.68-1.65 0-.01-.01-.02-.02-.04-.03-.06-.07-.12-.1-.18l-.18-.3c-.05-.07-.09-.14-.14-.21A8.528 8.528 0 0 0 11.79.08a.83.83 0 0 0-.88.12c-.27.21-.4.48-.4.83 0 .17.05.33.14.48.1.14.23.25.4.31 1.27.51 2.29 1.32 3.07 2.43.28.4.51.82.68 1.26.23.58.38 1.19.44 1.83v.07c0 .05 0 .09.01.14v.92c0 .05 0 .09-.01.14v.07c-.06.64-.21 1.25-.44 1.83-.06.15-.14.3-.21.45L16 12.37l.03-.06c.04-.06.07-.12.1-.18 0-.01.01-.02.02-.04.28-.52.51-1.07.68-1.65.2-.68.31-1.38.34-2.11v-.64h-.01ZM12.81 8.75c.04-.23.06-.46.06-.7v-.06c0-.24-.02-.47-.06-.7-.1-.54-.29-1.05-.57-1.52-.42-.7-1-1.22-1.75-1.57v2.68l2.23 2.23c.03-.12.07-.24.09-.36ZM8.59 2.73c0-.43-.19-.73-.58-.89-.39-.18-.73-.11-1.04.19l-.66.66 2.28 2.28V2.73ZM1.76.32C1.37-.07.74-.07.35.32s-.39 1.02 0 1.42l3.44 3.44H.95c-.27 0-.5.09-.68.27-.18.18-.27.41-.27.68v3.82c0 .27.09.5.27.68s.41.27.68.27h2.87l3.15 3.15c.3.3.65.37 1.04.2.39-.16.58-.46.58-.88V9.98l5.73 5.73c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.03 0-1.42L1.76.32Z' /></svg></span>
    </button>
  `);
  const muteOn = $muteButton.find('.js-mute-on');
  const muteOff = $muteButton.find('.js-mute-off');
  $slide.append($muteButton);

  $muteButton.on('click', () => {
    if (video.muted) {
      video.muted = false;
      muteOn.hide();
      muteOff.show();
    } else {
      video.muted = true;
      muteOn.show();
      muteOff.hide();
    }
  });
}

function handleVideo($videoSlides) {
  $.each($videoSlides, (i, slide) => {
    const $slide = $(slide);
    const videoURL = $slide.data('video');
    const posterURL = $slide.data('video-poster');
    let videoType;

    if (videoURL.toLowerCase().endsWith('.mp4')) {
      videoType = 'video';
    } else {
      videoType = 'unknown';
    }

    $slide.attr('data-media', videoType);

    const $video = renderVideoMarkup($slide, videoURL, posterURL);
    addMuteButton($slide, $video);
  });
}

/**
 * Wires up slick slider and provides hooks such that the internal can talk to
 * external functionality.
 */
export default class ImageCarousel {
  /**
   * @constructor
   * @param {HTMLElement|string} el - Element (or a selector) containing the slider
   * @param {Object} options - Any additional options based along to the slider
   */
  constructor(el, options = {}) {
    const $el = $(el);
    const {
      nextArrowTitle,
      previousArrowTitle,
    } = $el.data();

    const $videoSlides = $el.find('[data-video]');
    handleVideo($videoSlides);

    // Initialize
    $el.on('init', (slick) => {
      const $slick = $(slick.currentTarget);

      setTimeout(() => playPauseVideo($slick, 'play'), 1000);

      const expectedMedia = [];

      $('#detailsMarkup .image-carousel .slick-slide').each(function findImages() {
        if (!$(this).hasClass('slick-cloned')) {
          const $img = $(this).find('img');
          const imageSrc = $img.attr('src');
          const videoSrc = $(this).find('[data-video]').data('video');

          if (imageSrc) {
            expectedMedia.push(imageSrc);
          } else if (videoSrc) {
            expectedMedia.push(videoSrc);
          }
        }
      });

      expectedMedia.forEach((value, index) => {
        // if slide is video type, change the pagination to
        // show the play button instead of the default circle
        if (value.toLowerCase().endsWith('.mp4')) {
          $('.image-carousel__dots li').eq(index).children('.image-carousel__dot-button').addClass('image-carousel__dot-button--vid');
        }
      });
    });

    $el.on('beforeChange', (event, slick) => {
      const $slick = $(slick.$slider);
      playPauseVideo($slick, 'pause');
    });

    $el.on('afterChange', (event, slick) => {
      const $slick = $(slick.$slider);
      playPauseVideo($slick, 'play');
    });

    this.num = 0;
    this.$el = $el.slickAccessible($.extend({
      lazyLoad: 'ondemand',
      dots: true,
      dotsClass: `${BLOCK_NAME}__dots`,
      appendDots: $('.product__image--dots-container').eq(0),
      infinite: true,
      nextArrow: slickArrow('next', nextArrowTitle, 'arrow-right'),
      prevArrow: slickArrow('previous', previousArrowTitle, 'arrow-left'),
      rtl: _get(window, 'rcProps.isRtl', false),
      // Mock Content Start - AB Test 790 PDP Increased Slick Sensitivity
      touchThreshold: increasedSensitivity ? 20 : 5,
      // Mock Content End
      accessibility: true,
    }, options));
  }

  /**
   * Sets the active slider number for later use.
   * @param {number} currentNum - The number of the active slide
   */
  setSlideNumber(currentNum) {
    this.num = currentNum;
  }

  /**
   * Transitions or goes to the slide number based on the current state.
   */
  transitionSlide() {
    if (!isUndefined(this.num)) {
      this.$el.slick('slickGoTo', this.num, false);
    }
  }
}

registerJQueryPlugin('imageCarousel', (el, opts) => new ImageCarousel(el, opts));



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/image-carousel.js